import { render, staticRenderFns } from "./reg_carousel.vue?vue&type=template&id=70acedf8&scoped=true"
import script from "./reg_carousel.vue?vue&type=script&lang=js"
export * from "./reg_carousel.vue?vue&type=script&lang=js"
import style0 from "./reg_carousel.vue?vue&type=style&index=0&id=70acedf8&lang=css"
import style1 from "./reg_carousel.vue?vue&type=style&index=1&id=70acedf8&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acedf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70acedf8')) {
      api.createRecord('70acedf8', component.options)
    } else {
      api.reload('70acedf8', component.options)
    }
    module.hot.accept("./reg_carousel.vue?vue&type=template&id=70acedf8&scoped=true", function () {
      api.rerender('70acedf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landingpage/reg_carousel.vue"
export default component.exports